module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy2"
    }
  }, [_c('path', {
    attrs: {
      "id": "boy2_left_hand",
      "fill": "#A98448",
      "d": "M5572.26 349.12c.16 1.4 1.2 2.08 2.32 3.64 1.3 1.82 1.53 5.28 3.05 8.08-.27.7-2.5-.34-3.04-1.47-.56-1.13-.98-2.05-1.16-2.34-.18-.28-.54-.22-.63.07-.07.3.74 10.52.56 11.04-.17.53-1.45.68-1.72.18-.28-.5-1.1-8.56-1.24-8.77-.13-.2-.4-.07-.5.05-.1.13 1 8.73.86 9.07-.16.34-1.48.42-1.65.17-.16-.26-1.13-8.84-1.3-9.02-.16-.18-.44-.13-.54.05-.1.2 1.1 8.43.94 8.8-.17.38-1.44.52-1.6.17-.15-.35-1.3-8.64-1.44-8.75-.14-.12-.3-.1-.4.03-.1.12.43 6.35.26 6.7-.17.37-1.12.55-1.3.15-.2-.4-1.14-15.63-1.25-16.46-.36-2.8 1-5.9 4.34-6.24 3.36-.35 5.1 1.84 5.46 4.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_arm_bottom",
      "fill": "#A98448",
      "d": "M5565 315.1c-2.74.2-4.8 2.58-4.62 5.32l2.05 29.26c.2 2.74 2.57 4.8 5.3 4.6 2.74-.18 4.8-2.56 4.62-5.3l-2.05-29.25c-.2-2.74-2.57-4.8-5.3-4.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_arm_top",
      "fill": "#A98448",
      "d": "M5562.83 283.3c-2.74.2-4.8 2.56-4.6 5.3l2.2 31.74c.2 2.74 2.58 4.8 5.32 4.6 2.73-.18 4.8-2.55 4.6-5.3l-2.2-31.73c-.2-2.73-2.58-4.8-5.32-4.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_sleeve",
      "fill": "#D3A862",
      "d": "M5562.73 283.4c-2.8.2-4.95 2.52-4.95 5.32l.03 16.95 12.9-.9-2.33-16.8c-.38-2.76-2.85-4.76-5.64-4.57z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_bag_3",
      "width": "44.58",
      "height": "51.7",
      "x": "5519.66",
      "y": "277.98",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 11083.904 0)",
      "rx": "22.29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_shoe",
      "fill": "#BC9555",
      "d": "M5566.25 439c2.07.98 7.95 3.22 9.36 3.8 1.42.58 3.2 3.2 2.02 5.2h-24.02c-.8-.1-.8-3.1 0-9h12.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_leg_bottom",
      "fill": "#91713D",
      "d": "M5559.5 377c-4.14 0-7.5 3.36-7.5 7.5V439h15v-54.5c0-4.14-3.36-7.5-7.5-7.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_left_leg_top",
      "width": "15",
      "height": "64",
      "x": "5552",
      "y": "329",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 11119 0)",
      "rx": "7.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_shoe",
      "fill": "#BC9555",
      "d": "M5546.25 439c2.07.98 7.95 3.22 9.36 3.8 1.42.58 3.2 3.2 2.02 5.2h-24.02c-.8-.1-.8-3.1 0-9h12.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_leg_bottom",
      "fill": "#91713D",
      "d": "M5539.5 377c-4.14 0-7.5 3.36-7.5 7.5V439h15v-54.5c0-4.14-3.36-7.5-7.5-7.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_leg_top",
      "fill": "#91713D",
      "d": "M5539.5 329c-4.14 0-7.5 3.36-7.5 7.5v49c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5v-49c0-4.14-3.36-7.5-7.5-7.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_hip",
      "fill": "#91713D",
      "d": "M5567 332h-35v2.5c0 9.66 7.84 17.5 17.5 17.5s17.5-7.84 17.5-17.5V332z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_zipper",
      "fill": "#A98448",
      "d": "M5557 332h-5v15c4.7-3.24 5-6.64 5-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_torso",
      "fill": "#D3A862",
      "d": "M5562.73 284.84c-3.73-6.72-21.7-6.25-25.95 0-2.83 4.17-4.78 20.12-5.85 47.83h37.8c-1.5-27.4-3.5-43.34-6-47.83z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_bag_2",
      "fill": "#91713D",
      "d": "M5540.58 280.96c-1.68 0-5.4 1.78-5.72 3.28 1.1 12.02 2.8 34.45 2.95 36.65 5.7-3.23 14.46-32.76 2.78-39.94z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_bag_1",
      "fill": "#91713D",
      "d": "M5564.83 288.1c-.8-2.7-3.57-5.82-5.94-6.14 3.05 11.27 6.5 25.8 8.82 36.1-.46-8.6-1.82-26.35-2.9-29.97z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_hand",
      "fill": "#A98448",
      "d": "M5540.58 349.25c.06 1.4 1.03 2.17 2 3.8 1.14 1.92 1.14 5.42 2.42 8.33-.32.7-2.4-.52-2.85-1.7-.45-1.16-.8-2.12-.96-2.4-.16-.3-.52-.27-.62 0-.1.3 0 10.62-.2 11.13-.22.52-1.46.58-1.7.07-.23-.52-.5-8.68-.6-8.9-.1-.2-.38-.1-.5.03-.1.1.4 8.82.23 9.15-.16.33-1.45.32-1.6.05-.14-.26-.5-8.94-.65-9.13-.14-.2-.43-.16-.54 0-.1.2.52 8.55.33 8.9-.2.38-1.43.43-1.56.06-.12-.36-.68-8.76-.8-8.88-.13-.1-.3-.1-.4.02-.1.1 0 6.4-.2 6.75-.18.34-1.12.46-1.27.04-.16-.42-.04-15.75-.1-16.6-.15-2.83 1.37-5.84 4.64-5.96 3.26-.1 4.82 2.2 4.94 5.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_arm_bottom",
      "fill": "#A98448",
      "d": "M5536 315c-2.76 0-5 2.24-5 5v29c0 2.76 2.24 5 5 5s5-2.24 5-5v-29c0-2.76-2.24-5-5-5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy2_right_arm_top",
      "width": "10",
      "height": "42",
      "x": "5531",
      "y": "283",
      "fill": "#A98448",
      "transform": "matrix(-1 0 0 1 11072 0)",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_sleeve",
      "fill": "#D3A862",
      "d": "M5535.5 283c-2.8 0-5.15 2.18-5.34 5l-1.16 17h13l-1.16-17c-.2-2.82-2.53-5-5.34-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_neck",
      "fill": "#A98448",
      "d": "M5555.43 275.5c-.4 2.55-.54 3.57.57 4.96-.28.54-1.9 3.54-4.73 3.54-2.84 0-4.7-2.32-5.27-3.54 1-1.43.95-2.1.35-4.95.74-2.04 8.05-1.97 9.08 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_face",
      "fill": "#A98448",
      "fill-rule": "nonzero",
      "d": "M5534.88 258.15c-1.04-.63-2.53-1.42-4.22 0-1.44 1.2-.35 5.95 1.6 8.58 1.92 2.6 5.06 3.15 6.3 2.15 2.6 5.98 9.2 9.16 13.64 9.12 11.85-.1 16.8-12.36 16.8-22.54 0-16.05-6.28-21.46-16.8-21.46-9.44-.05-19.92 5.04-17.32 24.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_mouth_bottom",
      "fill": "#BC9555",
      "d": "M5557.8 273h-7.66c-.8 0 2.05 1 4.6 1 2.56 0 3.77-1 3.06-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_mouth_top",
      "fill": "#BC9555",
      "d": "M5558.75 273h-9.58c-1 0 2.56-2 5.76-2 3.2 0 4.7 2 3.82 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_nose",
      "fill": "#BC9555",
      "d": "M5555.9 258.7c-.14-.9-2.45-.96-2.52 0-.08.94-.8 6.67 0 7.67s3.18.66 3.55 0c.37-.66-.9-6.8-1.03-7.68z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M5557.68 259.38c1.4-3.26 7.63-3.76 8.56-.93 0 3.8-7.54 4.15-8.56.93z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_left_pupil",
      "cx": "5563.12",
      "cy": "259.24",
      "r": "2.14",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 11126.24 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M5549.34 259.38c-1.4-3.26-7.62-3.76-8.56-.93 0 3.8 7.54 4.15 8.56.93z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "boy2_right_pupil",
      "cx": "5545.72",
      "cy": "259.24",
      "r": "2.14",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 11091.44 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_left_brow",
      "fill": "#91713D",
      "d": "M5558.02 254.05c.27-1.36 8.8-1.38 8.97-.17.16 1.22-1.63.64-3.98.87-2.35.23-5.27.66-5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_right_brow",
      "fill": "#91713D",
      "d": "M5548.98 254.05c-.27-1.36-8.8-1.38-8.97-.17-.16 1.22 1.63.64 3.98.87 2.35.23 5.27.66 5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy2_hair",
      "fill": "#91713D",
      "d": "M5558.32 242.63c-.9 2.97-3.16 8.16-6.75 15.58l-1.1.14c-.42.05-.8-.25-.85-.67 0-.1 0-.18.02-.27l2.62-10.37-4.47 9.65c-.35.74-1.1 1.2-1.9 1.2-.54 0-.97-.4-.97-.94 0-.1.02-.2.06-.3l3.64-10.6-5.04 10.4c-.24.5-.74.8-1.28.8-.4 0-.73-.32-.73-.73v-.13c.83-4.2 1.23-6.84 1.2-7.88-.87 1.47-1.96 5.4-3.28 11.8-.1.56-.6.95-1.16.95-.47 0-.85-.38-.85-.85l.02-.1c.54-4.2.8-7.1.8-8.73-.88 1.95-1.88 5.8-3 11.6-.1.48-.53.83-1.02.83-.48 0-.88-.37-.92-.85l-.27-3.4-1.97 3.32c-.34.58-.97.93-1.64.93-.48 0-.85-.38-.85-.84 0-.07 0-.14.03-.2l2.84-10.97-3.62 6.62c-.34.62-1.12.85-1.74.5h-.02c-.64-.37-.9-1.16-.56-1.82l5.52-11.26-3.8 2.72c-.5.37-1.24.25-1.6-.27l-.04-.06c-.38-.6-.25-1.36.28-1.8l7.55-6.16-4.95 1.38c-.72.2-1.48-.18-1.76-.88-.26-.67.07-1.4.73-1.67h.03l18.4-6.54-6.64-2.28c-.6-.2-1-.77-1-1.4 0-.57.44-1.02 1-1.02h.06c7.32.5 13.9 2.73 19.76 6.72 6.3 1.2 11.7 5.25 16.2 12.1.4.58.3 1.35-.23 1.8-.46.4-1.17.37-1.58-.1 0-.02-.03-.03-.04-.05l-3.62-4.6 5.66 12.27c.23.5 0 1.1-.5 1.32l-.13.05c-.64.2-1.32-.12-1.6-.72l-3.44-7.38 1.78 8.98c.1.53-.24 1.04-.77 1.14h-.03c-.57.1-1.12-.24-1.3-.78l-4.38-12.78 1.15 10.46c.07.55-.32 1.05-.87 1.1h-.1c-.66 0-1.23-.45-1.36-1.08l-2.38-11.64.27 11.9c0 .63-.45 1.18-1.1 1.27-.57.1-1.1-.32-1.2-.9v-.06c-.65-7.83-1.07-12.65-1.25-14.47z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44242286","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/boyTwo.vue
// module id = 668
// module chunks = 1